/**
 * Aggregate the count of a key in a mapped object
 */
const addOrIncrement = (map: { [key: string]: number }, key?: string) => {
  if (key) {
    if (map[key] === undefined) {
      // eslint-disable-next-line no-param-reassign
      map[key] = 1;
    } else {
      // eslint-disable-next-line no-param-reassign
      map[key] += 1;
    }
  }
};

/**
 * Sort mapped object by count
 */
const sortTagsMap = (map: { [key: string]: number }) =>
  Object.entries(map)
    .sort(([_, a], [__, b]) => b - a)
    .slice(0, 2);

type Dict = { [key: string]: number };

/*
 * Format the review feedback with counts for each entry
 */
const reviewFeedback = (feedback: string[]): string => {
  const feedbackWithCounts = feedback.reduce((acc: Dict, cur) => {
    if (cur in acc) acc[cur] += 1;
    else acc[cur] = 1;
    return acc;
  }, {});

  return Object.entries(feedbackWithCounts)
    .sort((itemA, itemB) => itemA[1] - itemB[1])
    .map(([str, num]) => (num > 1 ? `${str} (${num})` : str))
    .join(", ");
};

export { addOrIncrement, sortTagsMap, reviewFeedback };
